import React, {PureComponent} from "react"
import CopyToClipboard from "react-copy-to-clipboard"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {Para} from "@irati/ui/src/Labels"
import Hr from "@irati/ui/src/Layout/Hr"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

import {Wrapper, SpacedPara, SpacedDiv, Link} from "../styled"

export enum Variant {
  SelfServe = "SELFSERVE",
  ITDepartment = "ITDEPARTMENT"
}

interface Props extends InjectIntl {
  variant: Variant
}

class Instructions extends PureComponent<Props> {
  render() {
    const {variant, formatMessage} = this.props
    const helpLink = (
      <Link href={formatMessage({id: "setup_tenant.steps.whitelist.helplink.href"})} target="_blank">
        <FormattedMessage id="setup_tenant.steps.whitelist.helplink.text" />
      </Link>
    )

    switch (variant) {
      case Variant.SelfServe:
        return (
          <Wrapper>
            <SpacedPara center large>
              <FormattedMessage id="setup_tenant.steps.whitelist.intro.shared" />
              <br />
              <FormattedMessage id="setup_tenant.steps.whitelist.intro.selfserveWithLink" values={{link: helpLink}} />
            </SpacedPara>
            <Hr />
            <Flex justifyContent="space-between">
              <div>
                <Para large>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.title" />
                </Para>
                <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.domain1" />
                <br />
                <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.domain2" />
              </div>
              <div>
                <Para large>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.title" />
                </Para>
                <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip1" />
                <br />
                <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip2" />
                <br />
                <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip3" />
              </div>
              <div>
                <CopyToClipboard text={formatMessage({id: "setup_tenant.steps.whitelist.main.shared.clipboardtext"})}>
                  <Button>
                    <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.button" />
                  </Button>
                </CopyToClipboard>
              </div>
            </Flex>
          </Wrapper>
        )

      case Variant.ITDepartment:
        return (
          <Wrapper>
            <SpacedPara center large>
              <FormattedMessage id="setup_tenant.steps.whitelist.intro.shared" />
              <br />
              <FormattedMessage id="setup_tenant.steps.whitelist.intro.itWithLink" values={{link: helpLink}} />
            </SpacedPara>
            <Hr />

            <Flex justifyContent="space-between">
              <SpacedDiv>
                <Para>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.it.part1" />
                </Para>
                <Para>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.it.part2" />
                </Para>
                <Para>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.title" />{" "}
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.domain1" />,
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.domains.domain2" />
                </Para>
                <Para>
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.title" />{" "}
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip1" />,
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip2" />,
                  <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.ip.ip3" />
                </Para>
              </SpacedDiv>
              <div>
                <CopyToClipboard text={formatMessage({id: "setup_tenant.steps.whitelist.main.it.clipboardtext"})}>
                  <Button>
                    <FormattedMessage id="setup_tenant.steps.whitelist.main.shared.button" />
                  </Button>
                </CopyToClipboard>
              </div>
            </Flex>
          </Wrapper>
        )
    }
  }
}

export default injectIntl(Instructions)
